module.exports = __webpack_public_path__ + "static/media/icon-3.3625d5a2.png";